import { render, staticRenderFns } from "./SettingsNotification.vue?vue&type=template&id=7160199b&scoped=true&"
import script from "./SettingsNotification.vue?vue&type=script&lang=js&"
export * from "./SettingsNotification.vue?vue&type=script&lang=js&"
import style0 from "./SettingsNotification.vue?vue&type=style&index=0&id=7160199b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160199b",
  null
  
)

export default component.exports